<mat-chip [selectable]="false" class="score-chip" 
	[ngClass]="{ 'good' : score >= 7, 'average': score >= 5 && score < 7, 'poor': score >=0 && score < 5, 'no-score': score===0 }">
	<span *ngIf="score!==0">{{customDigit| number:'1.1-2'}}</span>
	<span *ngIf="score===0">&#8212;</span>
</mat-chip>
